import * as React from 'react'
import { StoreProps } from '../../../../services/stores/casting.store'
import { I18nService } from '../../../../services/utils/i18n.service'

type Props = StoreProps & { rows: number }

const i18nScoped = new I18nService(require('./casting-message.component.yml'))
export default function CastingMessageComponent ({ store, data: { message }, rows }: Props) {
  return <>
    <textarea id="js-test-message" placeholder={ i18nScoped.t('let_a_message') } value={ message ?? '' } onChange={ event => store.set({ message: event.target.value }) } rows={ rows } maxLength={ 1000 } />
    <p className="u-txtRight">{ message?.length || 0 } / { 1000 }</p>
  </>
}
